import { useEffect, useState, lazy, Suspense } from "react";
import { api } from "./api.js";
import { useLang, t } from "./i18n.jsx";
import LoginScreen from "./components/LoginScreen.jsx";
import Shell from "./components/Shell.jsx";

// Panouri secundare, încărcate la cerere (după autentificare) — nu blochează
// primul randare (ecranul de login) cu JS/CSS de care nu are nevoie.
const ClientsPanel = lazy(() => import("./components/ClientsPanel.jsx"));
const UsersPanel = lazy(() => import("./components/UsersPanel.jsx"));
const ProcesePanel = lazy(() => import("./components/ProcesePanel.jsx"));
const DocumentePanel = lazy(() => import("./components/DocumentePanel.jsx"));

function PanelFallback({ lang }) {
  return <div className="empty-hint">{t(lang, "Se încarcă…")}</div>;
}

export default function App() {
  const [user, setUser] = useState(null);
  const [tab, setTab] = useState("documente");
  const [ready, setReady] = useState(false);
  const [lang, setLang] = useLang();

  useEffect(() => {
    if (api.isAuthenticated()) setUser(api.getStoredUser());
    setReady(true);
  }, []);

  if (!ready) return null;

  if (!user) {
    return <LoginScreen onLoggedIn={setUser} lang={lang} onLangChange={setLang} />;
  }

  async function logout() {
    await api.logout();
    setUser(null);
  }

  return (
    <Shell user={user} tab={tab} onTab={setTab} onLogout={logout} lang={lang} onLangChange={setLang}>
      <Suspense fallback={<PanelFallback lang={lang} />}>
        {tab === "documente" && <DocumentePanel user={user} lang={lang} />}
        {tab === "clienti" && user.role !== "CLIENT_REVIEWER" && <ClientsPanel user={user} lang={lang} />}
        {tab === "procese" && user.role !== "CLIENT_REVIEWER" && <ProcesePanel user={user} lang={lang} />}
        {tab === "utilizatori" && user.role === "OWNER" && <UsersPanel lang={lang} />}
      </Suspense>
    </Shell>
  );
}
